// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/HorizontalLegend/HorizontalLegend.less
// module id = 1067
// module chunks = 0